<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>红人维度 <span style="font-weight: lighter;font-size: 10px">（{{ condition.year }}年{{ condition.month }}月
        <el-tooltip class="item" effect="dark"
                    :content="`统计数据来源：${condition.year}年${condition.month}月内下单的订单`"
                    placement="top-start">
                <i class="el-icon-info" style="cursor: pointer;color: #8a8e99"/>
        </el-tooltip>）</span></span>

      <el-tooltip class="item" effect="dark" :content="`同步到飞书：${condition.year}年${condition.month}月的红人维度数据`"
                  placement="top-start">
        <el-button style="float: right; margin-left: 10px;" size="mini" type="primary" plain icon="el-icon-upload2"
                   @click="openSyncDialog" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="`刷新：${condition.year}年${condition.month}月的红人维度数据`"
                  placement="top-start">
        <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                 title="点击刷新"
                 @click="getData" :disabled="loading" :loading="loading"><i
            class="el-icon-refresh-right"/></el-link>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="`导出：${condition.year}年${condition.month}月的红人维度数据`"
                  placement="top-start">
        <summary-export-link style="float: right" filename="红人排行" :params="{...{tag: 'artist'},...condition}"/>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="`平台分布：${condition.year}年${condition.month}月的红人维度数据`"
                  placement="top-start">
        <el-link style="float: right; padding: 3px 0;margin-left: 10px" type="primary" :underline="false"
                 title="平台分布"
                 @click="showDrawer">
          <i class="el-icon-s-grid"/></el-link>
      </el-tooltip>
    </div>
    <el-table class="dashboard-table"
              show-summary
              :summary-method="getSummaries"
              :data="data"
              :row-style="{ border: 'none',padding:'15px 0'}"
              :cell-style="{ border: 'none'}"
              style="width: 100%"
              v-loading="loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading">
      <el-table-column prop="index" label="序号" width="80" align="left">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="红人" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link type="primary" style="font-size: 12px" @click="toDetail(scope.row)">
            {{ scope.row.name }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="order_money" :label="`订单金额(元)`" align="right" min-width="120" sortable
                       header-align="right">
        <template slot-scope="scope">
          <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rank" label="销售额排名" min-width="120" align="center" sortable/>
      <el-table-column prop="last_rank" label="(上月)销售额排名" min-width="120" align="center" sortable/>
      <el-table-column prop="rank_diff" :label="`销售额排名↑↓`" align="center" min-width="120">
        <template slot-scope="scope">
          <span style="color: #f50027" v-if="scope.row.rank_diff>0">↑{{ scope.row.rank_diff }}</span>
          <span style="color: #00c297"
                v-else-if="scope.row.rank_diff<0">↓{{ -1 * scope.row.rank_diff }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_count" label="(普通)订单数" align="right" min-width="120" header-align="right"
                       sortable/>
      <el-table-column prop="qty_rank" label="单量排名" min-width="110" align="center" sortable/>
      <el-table-column prop="last_qty_rank" label="(上月)单量排名" min-width="110" align="center" sortable/>
      <el-table-column prop="qty_rank_diff" :label="`单量排名↑↓`" align="center" min-width="120">
        <template slot-scope="scope">
          <span style="color: #f50027" v-if="scope.row.qty_rank_diff>0">↑{{ scope.row.qty_rank_diff }}</span>
          <span style="color: #00c297"
                v-else-if="scope.row.qty_rank_diff<0">↓{{ -1 * scope.row.qty_rank_diff }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>


      <el-table-column prop="order_exec_count" :label="`已执行单数`" min-width="120" align="right"
                       header-align="right"/>
      <el-table-column prop="order_percent_count" :label="`单量占比`" min-width="120" align="right"
                       header-align="right">
        <template slot-scope="scope">
          <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_count, 1) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_percent_money" :label="`销售额占比`" align="right" min-width="120"
                       header-align="right">
        <template slot-scope="scope">
          <span class="rate">{{ gFunc.numberFormat(scope.row.order_percent_money, 1) }}</span>
        </template>
      </el-table-column>

    </el-table>

    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose">
      <template slot="ape-drawer">
        <div style="text-align: left">
          <ArtistPlatformData ref="refArtistPlatformData"/>
        </div>
      </template>
    </ApeDrawer>

    <el-dialog title="同步红人维度到飞书多维表格" :visible.sync="dialogSyncVisible" width="760px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        将当前{{ condition.year }}年{{ condition.month }}月的红人维度同步到飞书多维表格，每个红人写入一条记录。<br/>
        「月份」若选择「日期」类型，将按「年份 + 月份」写入日期（取当月 1 号）。
      </div>
      <el-form :model="syncForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="syncForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="数据表 ID">
          <div style="display: flex;align-items: center;">
            <el-input v-model="syncForm.table_id" placeholder="tblxxxxxxxxxx（必填）" clearable style="flex:1"/>
            <el-button style="margin-left: 8px;" size="mini" type="primary" plain icon="el-icon-plus"
                       @click="openCreateTableDialog">新增数据表</el-button>
          </div>
        </el-form-item>
        <el-form-item label="写入模式">
          <el-radio-group v-model="syncForm.mode">
            <el-radio label="append">追加（每次同步新增记录）</el-radio>
            <el-radio label="replace">覆盖（先清空目标表再写入）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="syncForm.fields" size="mini" border>
            <el-table-column label="数据源字段" width="200">
              <template slot-scope="{row}">
                <span>{{ row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column label="飞书列名" width="220">
              <template slot-scope="{row}">
                <el-input v-model="row.name" size="mini" placeholder="列名"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="110">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="同步" width="70" align="center">
              <template slot-scope="{row}">
                <el-switch v-model="row.enabled" size="mini"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-copy" style="color:#409EFF"
                       @click="copySyncFieldsAsBitableJson">复制为飞书JSON</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSyncVisible = false">取 消</el-button>
        <el-button @click="handleSaveSyncConfig">保存为全局默认</el-button>
        <el-button type="primary" :loading="syncLoading" @click="handleSyncArtist" v-permission="'dashboard_btn_sync_fs'">同步到飞书</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增数据表（同步红人维度）" :visible.sync="createTableVisible" width="620px"
               :close-on-click-modal="false" append-to-body>
      <div style="margin-bottom: 14px;color:#606266;font-size:13px;">
        在当前多维表格 App 内新建一个数据表，创建成功后会自动把数据表 ID 回填到上方「数据表 ID」。
      </div>
      <el-form :model="createTableForm" label-width="110px" label-position="right">
        <el-form-item label="多维表格 App Token">
          <el-input v-model="createTableForm.app_token" placeholder="bascxxxxxxxxxx（必填）" clearable/>
        </el-form-item>
        <el-form-item label="表名称">
          <el-input v-model="createTableForm.name" placeholder="数据表名称，如：红人维度" clearable/>
        </el-form-item>
        <el-form-item label="默认视图名">
          <el-input v-model="createTableForm.default_view_name" placeholder="可选，如 表格视图" clearable/>
        </el-form-item>
        <el-form-item label="自定义字段">
          <el-table :data="createTableForm.fields" size="mini" border>
            <el-table-column label="字段名称">
              <template slot-scope="{row}">
                <el-input v-model="row.field_name" size="mini" placeholder="字段名称"/>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="150">
              <template slot-scope="{row}">
                <el-select v-model="row.type" size="mini" style="width:100%">
                  <el-option v-for="opt in fieldTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="{$index}">
                <el-button type="danger" icon="el-icon-delete" circle size="mini"
                           @click="removeCreateTableField($index)"/>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 8px;">
            <el-button type="text" icon="el-icon-document-add"
                       @click="createBatchJsonVisible = !createBatchJsonVisible">
              批量粘贴 JSON 生成字段
            </el-button>
            <el-input v-if="createBatchJsonVisible" v-model="createBatchJson" type="textarea" :rows="4"
                      placeholder='JSON 数组，每项生成一行字段，如 [{"field_name":"订单金额","type":2}]'/>
            <div v-if="createBatchJsonVisible" style="margin-top: 6px;">
              <el-button size="mini" type="primary" @click="applyCreateBatchJson">生成字段</el-button>
            </div>
          </div>
          <el-button style="margin-top: 8px;" type="text" icon="el-icon-plus"
                     @click="addCreateTableField">添加字段</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createTableVisible = false">取 消</el-button>
        <el-button type="primary" :loading="createTableLoading" @click="handleCreateTable">新增数据表</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {getDashboardArtistMonth} from "@/api/dashboard";
import {feishuArtistSyncConfig, saveFeishuArtistSyncConfig, feishuSyncArtist, feishuCreateTable} from "@/api/feishu";
import {copyToClipboard} from "@/utils/security";
import ApeDrawer from "@/components/ApeDrawer";
import ArtistPlatformData from "@/components/summary/ArtistPlatformData/Index";
import SummaryExportLink from "@/components/summary/ExportLink.vue";

export default {
  name: "SummaryArtist",
  inject: ['condition'],
  components: {SummaryExportLink, ApeDrawer, ArtistPlatformData},
  data() {
    return {
      loading: false,
      exportLoading: false,
      data: [],
      platformsTableHeader: [],
      dialogSyncVisible: false,
      syncLoading: false,
      fieldTypeOptions: [
        {value: 1, label: '文本'},
        {value: 2, label: '数字'},
        {value: 3, label: '单选'},
        {value: 5, label: '日期'},
        {value: 7, label: '复选框'}
      ],
      syncForm: {app_token: '', table_id: '', mode: 'append', fields: []},
      createTableVisible: false,
      createTableLoading: false,
      createTableForm: {app_token: '', name: '', default_view_name: '', fields: []},
      createBatchJsonVisible: false,
      createBatchJson: '',
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: `红人各平台数据`,
        width_height: '80%',
        show_footer: false,
      },
    }
  },
  created() {
    this.getData()
  },
  watch: {
    condition: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    // 处理搜索条件
    handleSearchCondition() {
      return this.condition
    },
    getData() {
      this.loading = true
      this.data = []
      const searchCondition = this.handleSearchCondition()
      getDashboardArtistMonth(searchCondition).then(res => {
        this.loading = false
        this.data = res.model.data;
        this.platformsTableHeader = res.model.platforms_head ? Array.from(Object.values(res.model.platforms_head)) : [];
        this.total_count = res.model.total_count
        this.total_money = res.model.total_money
      })
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        // const array = [...this.platformsTableHeader, ...['order_money', 'order_percent_money', 'order_exec_count', 'order_count', 'order_percent_count']];
        const array = ['order_money', 'order_percent_money', 'order_exec_count', 'order_count', 'order_percent_count'];
        if (array.indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "order_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
          }
        }
      });
      return sums
    },
    openCreateTableDialog() {
      // 用当前填写的 app_token 预填，免去重复输入
      this.createTableForm.app_token = this.syncForm.app_token || ''
      this.createTableVisible = true
    },
    // 解析批量粘贴的 JSON（必须是数组）
    parseBatchFieldJson(str) {
      if (!str || !str.trim()) {
        this.$message.warning('请先粘贴 JSON 内容')
        return null
      }
      let parsed
      try {
        parsed = JSON.parse(str)
      } catch (e) {
        this.$message.error('不是合法的 JSON，请检查格式')
        return null
      }
      if (!Array.isArray(parsed)) {
        this.$message.error('需为 JSON 数组，如 [{...},{...}]')
        return null
      }
      return parsed
    },
    // 新增数据表弹窗：批量 JSON 生成字段（一次性追加多行）
    applyCreateBatchJson() {
      const parsed = this.parseBatchFieldJson(this.createBatchJson)
      if (!parsed) {
        return
      }
      const rows = parsed.map(item => ({
        field_name: item.field_name || '',
        type: item.type || 1
      }))
      this.createTableForm.fields.push(...rows)
      this.$message.success(`已批量生成 ${rows.length} 个字段`)
      this.createBatchJson = ''
      this.createBatchJsonVisible = false
    },
    // 同步弹窗：把已启用且有列名的字段导出为飞书多维表格字段 JSON（[{field_name,type}]），供「新增数据表」建列
    copySyncFieldsAsBitableJson() {
      const rows = (this.syncForm.fields || [])
        .filter(item => item.enabled !== false && (item.name || '').trim())
        .map(item => ({
          field_name: (item.name || '').trim(),
          type: item.type || 1
        }))
      if (!rows.length) {
        this.$message.warning('暂无已启用的同步字段可复制')
        return
      }
      copyToClipboard(JSON.stringify(rows)).then(() => {
        this.$message.success(`已复制 ${rows.length} 个飞书多维表格字段的 JSON 到剪贴板`)
      })
    },
    addCreateTableField() {
      this.createTableForm.fields.push({field_name: '', type: 1})
    },
    removeCreateTableField(index) {
      this.createTableForm.fields.splice(index, 1)
    },
    handleCreateTable() {
      if (!this.createTableForm.app_token) {
        this.$message.warning('请填写多维表格 App Token')
        return
      }
      if (!this.createTableForm.name) {
        this.$message.warning('请填写表名称')
        return
      }
      const payload = {
        app_token: this.createTableForm.app_token,
        name: this.createTableForm.name,
        default_view_name: this.createTableForm.default_view_name,
        fields: this.createTableForm.fields.filter(item =>
          item.field_name !== null && item.field_name !== '' && item.field_name !== undefined)
      }
      this.createTableLoading = true
      feishuCreateTable(payload).then(res => {
        this.createTableLoading = false
        if (res && res.success) {
          this.createTableVisible = false
          // 新增成功，把新数据表 ID 回填到同步表单
          if (res.data && res.data.table_id) {
            this.syncForm.table_id = res.data.table_id
          }
          this.$message.success('新增数据表成功，已回填数据表 ID')
        }
      }).catch(() => {
        this.createTableLoading = false
      })
    },
    openSyncDialog() {
      this.dialogSyncVisible = true
      // 拉取全局默认同步配置填充
      feishuArtistSyncConfig().then(res => {
        if (res && res.success) {
          this.syncForm.app_token = res.data.app_token || ''
          this.syncForm.table_id = res.data.table_id || ''
          this.syncForm.mode = res.data.mode || 'append'
          this.syncForm.fields = (res.data.fields || []).map(f => ({...f}))
        }
      })
    },
    buildSyncPayload() {
      return {
        app_token: this.syncForm.app_token,
        table_id: this.syncForm.table_id,
        mode: this.syncForm.mode,
        fields: (this.syncForm.fields || []).map(f => ({
          field: f.field,
          name: f.name,
          type: f.type,
          enabled: !!f.enabled
        }))
      }
    },
    handleSaveSyncConfig() {
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      saveFeishuArtistSyncConfig(this.buildSyncPayload()).then(res => {
        if (res && res.success) {
          this.$message.success('已保存为全局默认同步配置')
        }
      })
    },
    handleSyncArtist() {
      if (!this.syncForm.app_token || !this.syncForm.table_id) {
        this.$message.warning('请填写多维表格 App Token 和数据表 ID')
        return
      }
      this.syncLoading = true
      const payload = this.buildSyncPayload()
      payload.year = this.condition.year
      payload.month = this.condition.month
      payload.organization_id = this.condition.organization_id || ''
      feishuSyncArtist(payload).then(res => {
        this.syncLoading = false
        if (res && res.success) {
          this.$message.success(`同步成功：共 ${res.data.records || 0} 条红人数据，新增 ${res.data.created || 0} 条记录`)
          this.dialogSyncVisible = false
        }
      }).catch(() => {
        this.syncLoading = false
      })
    },
    toDetail(row) {
      const {href} = this.$router.resolve({
        name: `homeArtistDetail`,
        query: {
          artistId: row.artist_id,
          artistName: row.name,
          year: this.condition.year,
          organization_id: this.condition.organization_id
        }
      });
      window.open(href, "_blank");
    },
    showDrawer() {
      this.drawerData.title = `${this.condition.year}年${this.condition.month}月红人各平台数据`
      this.drawerData.visible = true
      this.drawerData.loading = false
      this.$nextTick(() => {
        this.$refs['refArtistPlatformData'].init({year: this.condition.year, month: this.condition.month, organization_id: this.condition.organization_id})
      })
    },
    async drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    drawerConfirm() {
      // 保存
    },
  }
}
</script>

<style>
.caret-wrapper {
  width: 8px !important;
}

</style>
